import script from "./ds-datepicker.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20Date%20%7C%20Date%5B%5D"
export * from "./ds-datepicker.vue?vue&type=script&lang=ts&setup=true&generic=T%20extends%20Date%20%7C%20Date%5B%5D"

const __exports__ = script;

export default __exports__